import type JCE from '@chesscom/js-chess-engine';

type Node = JCE.Node.Model | JCE.Position.Starting;

/**
 * Get the move number from a node or starting position.
 */
function getMoveNumber(node: Node): number {
  const { moveNumber } = <JCE.Node.Model>node;

  return typeof moveNumber !== 'undefined' ? moveNumber : -1;
}

/**
 * Get the ply diff between two nodes.
 */
export function getPlyDiff(before: Node, after: Node): number {
  return getMoveNumber(after) - getMoveNumber(before);
}
